import { render, staticRenderFns } from "./EntityViewer.vue?vue&type=template&id=36d06eb9&scoped=true&"
import script from "./EntityViewer.vue?vue&type=script&lang=ts&"
export * from "./EntityViewer.vue?vue&type=script&lang=ts&"
import style0 from "./EntityViewer.vue?vue&type=style&index=0&id=36d06eb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d06eb9",
  null
  
)

export default component.exports